// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__lje-Q","fadeDown":"Modal_fadeDown__WBAQL","scale":"Modal_scale__zO8m2"};